import React from 'react';
import { Container, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  question: {
    color: '#192a63',
    marginTop: 20,
  },
  description: {
    color: '#6f7d92',
    fontSize: 20,
    marginTop: 20,
  },
});

const Question = ({ questionNo, questionText, description }) => {
  const classes = useStyles();
  return (
    <Container maxWidth="md">
      <div
        className={'mt-10px text-base md:text-xl'}
        style={{ color: '#192a63' }}
      >
        Frage {questionNo}
      </div>
      <div
        className={'mt-10px text-xl md:text-3xl'}
        style={{ color: '#6f7d92' }}
      >
        {questionText}
      </div>
      <Typography className={classes.description}>{description}</Typography>
    </Container>
  );
};

export default Question;
